/**
 * m-spec-tab-link.js
 *
 * Enhances in-page links that point to product details tabs, switching tabs
 * if a different one is currently selected before smoothly scrolling the
 * section into view.
 *
 * Fixed tab indices from sections/m-product-details.liquid:
 * - Specification: button `#tab-4`, panel `#panel-4`
 * - Reviews: button `#tab-5`, panel `#panel-5`
 */
(() => {
  const DETAILS_ID = 'product-details';
  const LINK_SELECTOR = 'a[href$="#product-details"], a[href$="#product-reviews"]';
  const TAB_TARGETS = {
    '#product-details': 'panel-4',
    '#product-reviews': 'panel-5',
  };

  /**
   * Activates a tab within the details section, if present and not already
   * selected. Clicking the tab button lets tabs.js handle aria state and
   * panel visibility for us.
   * @param {Element} details - The #product-details container.
   * @param {string} panelId - The panel controlled by the target tab.
   */
  function activateTab(details, panelId) {
    const tab = details.querySelector(`[role="tab"][aria-controls="${panelId}"]`);
    if (tab && tab.getAttribute('aria-selected') !== 'true') {
      tab.click();
    }
  }

  /**
   * Handles delegated clicks on links targeting product details tabs.
   * @param {MouseEvent} evt - Event object.
   */
  function handleClick(evt) {
    if (evt.defaultPrevented) return;

    const link = evt.target.closest(LINK_SELECTOR);
    if (!link) return;

    const hash = new URL(link.getAttribute('href'), window.location.href).hash;
    const panelId = TAB_TARGETS[hash];
    if (!panelId) return;

    const details = document.getElementById(DETAILS_ID);
    if (!details) return;

    evt.preventDefault();
    activateTab(details, panelId);
    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', hash);
  }

  document.addEventListener('click', handleClick);
})();
